import { render, staticRenderFns } from "./sbSelectToyDialog.vue?vue&type=template&id=afc61ac8&scoped=true"
import script from "./sbSelectToyDialog.vue?vue&type=script&lang=ts"
export * from "./sbSelectToyDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc61ac8",
  null
  
)

export default component.exports